import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import {AiAssistantNode, NODE_TYPE} from "./aiAssistant";
import {FormGroup} from "@angular/forms";
import {AiAssistantIds, AiAssistantService} from "./ai-assistant.service";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {map, tap} from "rxjs/operators";

@Component({
    selector: 'app-ai-assistant',
    templateUrl: './ai-assistant.component.html',
    styleUrls: ['./ai-assistant.component.scss']
})
export class AiAssistantComponent extends NodeBuilder implements OnInit {

    AiAssistantForm: FormGroup = null;
    assistantIds: AiAssistantIds[] = undefined;
    assistantIdsFiltered: AiAssistantIds[] = undefined;

    constructor(private assistantService: AiAssistantService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
        this.assistantService.getAiAssistants()
            .pipe(
                tap(aiAssistants => {
                    this.assistantIds = aiAssistants;
                    this.assistantIdsFiltered = aiAssistants;
                })
            )
            .subscribe();
    }

    set buildForm(stepData: any) {

        this.AiAssistantForm = AiAssistantNode.toForm(stepData, this.canEdit);


        if (this.AiAssistantForm.get('errorNext').value === newStepValue) {
            this.AiAssistantForm.get('errorNext').setValue('step' + this.getNextStep());
        }
        if (this.AiAssistantForm.get('successNext').value === newStepValue) {
            this.AiAssistantForm.get('successNext').setValue('step' + this.getNextStep());
        }


    }

    get getStepData(): {} {

        const node = new AiAssistantNode();
        node.setNodeData(this.AiAssistantForm.getRawValue());

        return node.nodeData;
    }

    get isNodeValid(): boolean {
        this.AiAssistantForm.markAllAsTouched();
        return this.AiAssistantForm.valid;
    }


    public assistantIdFilter(element: HTMLInputElement) {
        const filterValue = element.value;
        this.assistantIdsFiltered = this.assistantIds?.filter(option => option.name.includes(filterValue));
    }

    assistantIdDisplay(id: string): string {
        if (this.assistantIds && id) {
            return this.assistantIds.find(value => value.assistantId === id).name;
        }

        return '';
    }
}
